import PropTypes from 'prop-types';
import Table from '../../ui/Table';

const ListadoSolicitudes = ({ dataApi, onLoadMore, isLoadingMore, hasMore }) => {
  const columns = [
    {
      Header: 'Número matrícula',
      accessor: 'num_matricula',
    },
    {
      Header: 'Fecha',
      accessor: 'fecha',
    },
    {
      Header: 'Fecha confirmación',
      id: 'fechaConfirmacion',
      accessor: (row) => row.fechaConfirmacion || row.fecha,
    },
    {
      Header: 'Fecha baja',
      id: 'fechaBaja',
      accessor: (row) => row.fechaBaja || '',
    },
    {
      Header: 'Nombre',
      accessor: 'nombre',
    },
    {
      Header: 'Apellidos',
      accessor: 'apellidos',
    },
    {
      Header: 'Grupo',
      accessor: 'nombre_grupo',
    },
    {
      Header: 'Centro',
      accessor: 'centro',
    },
    {
      Header: 'Ciclo',
      accessor: 'ciclo',
    },
    {
      Header: 'Tipo',
      accessor: 'curso',
    },
    {
      Header: 'Estado',
      accessor: 'estado',
    },
    {
      Header: 'Acciones',
      accessor: 'actions',
    },
  ];

  return (
    <div style={{ marginTop: '16px' }}>
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        marginBottom: '8px', padding: '0 4px',
      }}>
        <span style={{ fontSize: '0.8rem', fontWeight: 600, color: '#374151' }}>
          Resultados
        </span>
        <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>
          {dataApi.length} matrícula{dataApi.length !== 1 ? 's' : ''}
          {hasMore && ' (hay más resultados)'}
        </span>
      </div>
      <Table
        columns={columns}
        data={dataApi}
        defaultPageSize={10}
        showPaginationBottom
        onLoadMore={onLoadMore}
        isLoadingMore={isLoadingMore}
        hasMore={hasMore}
      />
    </div>
  );
};

ListadoSolicitudes.propTypes = {
  dataApi: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onLoadMore: PropTypes.func,
  isLoadingMore: PropTypes.bool,
  hasMore: PropTypes.bool,
};

export default ListadoSolicitudes;
